import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api } from '../api/client';
import { useAuth } from '../auth/auth-context';
import { Tag } from '../components/Tag';
import { Campo, Form, PageHeader } from '../components/ui';

export function MinhaConta() {
  const { usuario, ehSuperadmin } = useAuth();
  const [ok, setOk] = useState<string | null>(null);

  const trocarSenha = useMutation({
    mutationFn: (dados: Record<string, string>) => {
      if (dados.novaSenha !== dados.confirmacao) {
        throw new Error('As senhas não conferem.');
      }
      return api<{ sessoesEncerradas: number }>('/auth/change-password', {
        method: 'POST',
        body: { currentPassword: dados.senhaAtual, newPassword: dados.novaSenha },
      });
    },
    onSuccess: (resposta) => {
      setOk(
        resposta.sessoesEncerradas > 0
          ? `Senha alterada. ${resposta.sessoesEncerradas} outra(s) sessão(ões) foram encerradas.`
          : 'Senha alterada.',
      );
    },
  });

  return (
    <>
      <PageHeader titulo="Minha conta" />

      <div className="grade-detalhe">
        <div className="card">
          <div className="secao-titulo">
            <i className="ti ti-lock" /> Trocar senha
          </div>

          <Form
            aoEnviar={(dados) => {
              setOk(null);
              trocarSenha.mutate(dados);
            }}
          >
            {trocarSenha.isError && (
              <div className="form-erro">{(trocarSenha.error as Error).message}</div>
            )}
            {ok && (
              <div className="aviso" style={{ marginBottom: 16 }}>
                <i className="ti ti-check" />
                <span>{ok}</span>
              </div>
            )}

            <Campo label="Senha atual" name="senhaAtual" tipo="password" obrigatorio />
            <Campo
              label="Nova senha"
              name="novaSenha"
              tipo="password"
              obrigatorio
              ajuda="Mínimo de 10 caracteres."
            />
            <Campo label="Confirme a nova senha" name="confirmacao" tipo="password" obrigatorio />

            <button className="btn btn-primary" type="submit" disabled={trocarSenha.isPending}>
              {trocarSenha.isPending ? 'Alterando…' : 'Alterar senha'}
            </button>

            <p style={{ fontSize: 11, color: 'var(--text-dim)', marginTop: 12, lineHeight: 1.5 }}>
              Trocar a senha encerra suas outras sessões. Esta continua ativa.
            </p>
          </Form>
        </div>

        <div className="card">
          <div className="secao-titulo">
            <i className="ti ti-id" /> Dados
          </div>

          <dl className="lista-dados">
            <dt>Nome</dt>
            <dd>{usuario?.name}</dd>
            <dt>E-mail</dt>
            <dd>{usuario?.email}</dd>
            <dt>Escopo</dt>
            <dd>
              <Tag type={ehSuperadmin ? 'accent' : 'info'}>
                {ehSuperadmin ? 'Plataforma' : 'Organização'}
              </Tag>
            </dd>
            {usuario?.organization && (
              <>
                <dt>Organização</dt>
                <dd>{usuario.organization.tradeName}</dd>
              </>
            )}
          </dl>

          <div className="divider" style={{ margin: '18px 0' }} />

          <div className="secao-titulo">
            <i className="ti ti-key" /> Permissões ({usuario?.permissions.length ?? 0})
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {usuario?.permissions.map((p) => (
              <Tag key={p} type="muted">
                {p}
              </Tag>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
